<template>
  <div class="py-4">
    <nav
      class="relative z-0 inline-flex rounded-md shadow-sm -space-x-px flex-wrap"
      aria-label="Pagination"
    >
      <NuxtLink v-if="currentPage != 1"
        :to="'?page=' + (currentPage - 1)"
        @click="$emit('update:currentPage', currentPage - 1)"
        class="
          relative
          inline-flex
          items-center
          px-2
          py-2
          rounded-l-md
          border border-gray-300
          bg-white
          text-sm
          font-medium
          text-gray-500
          hover:bg-gray-50
        "
      >
        <span class="sr-only">Previous</span>
        <svg
          class="h-5 w-5"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            fill-rule="evenodd"
            d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
            clip-rule="evenodd"
          />
        </svg>
      </NuxtLink>
      <span v-for="n in numberOfPages" :key="n">
        <NuxtLink
          @click="$emit('update:currentPage', n)"
          :to="'?page=' + n"
          aria-current="page"
          class="
            relative
            inline-flex
            items-center
            px-4
            py-2
            border
            text-sm
            font-medium
          "
          :class="[
            n == currentPage
              ? 'z-10  bg-darkRed border-darkRed text-white'
              : 'bg-white border-gray-300 text-darkRed hover:bg-gray-50 ',
          ]"
        >
          {{ n }}
        </NuxtLink>
      </span>
      <NuxtLink
        v-if="currentPage != numberOfPages"
        :to="`?page=${currentPage + 1}`"
        @click="$emit('update:currentPage', currentPage + 1)"
        class="
          relative
          inline-flex
          items-center
          px-2
          py-2
          rounded-r-md
          border border-gray-300
          bg-white
          text-sm
          font-medium
          text-darkRed
          hover:bg-gray-50
        "
      >
        <span class="sr-only">Next</span>
        <svg
          class="h-5 w-5"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            fill-rule="evenodd"
            d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
            clip-rule="evenodd"
          />
        </svg>
      </NuxtLink>
    </nav>
  </div>
</template>
<script>
export default {
  name: "Pagination",
};
</script>
<script setup>
  defineProps(["numberOfPages", "currentPage"]);
</script>
